import axios from "axios";
import config from "../config/env";
// 创建 Axios 实例
const axiosApi = axios.create({
  baseURL: config.apiBaseUrl,
  timeout: 300000, // 超时时间
});

const err = (error) => {
  if (error.response) {
    let data = error.response.data;
    switch (error.response.status) {
      case 403:
        // Notification.error({
        //   title: "系统提示",
        //   message: "拒绝访问",
        //   duration: 4000,
        // });
        break;
      case 404:
        // Notification.error({
        //   title: "系统提示",
        //   message: "很抱歉，资源未找到!",
        //   duration: 4000,
        // });
        break;
      case 504:
        // Notification.error({ title: "系统提示", message: "网络超时" });
        break;
      case 401:
        //   redirectLogin("未授权，请重新登录");
        break;
      default:
        // Notification.error({
        //   title: "系统提示",
        //   message: !data.message ? "系统异常，请联系管理员" : data.message,
        //   duration: 4000,
        // });
        break;
    }
  }
  return Promise.reject(error);
};

// 添加请求拦截器
axiosApi.interceptors.request.use(
  (config) => {
    // 在请求发送之前做一些处理，比如添加 token
    console.log("请求拦截器:", config);
    if (config.method === "get") {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axiosApi.interceptors.response.use((response) => {
  return response.data;
}, err);

export default axiosApi;
